/**
 * Handle UCPH open house events filter
 */
document.addEventListener('DOMContentLoaded', () => {
    'use strict'
    let translations;
    if (document.documentElement.lang === 'da') {
        translations = {
            'nodata': 'Ingen uddannelser matcher din søgning.',
            'fewresults': '<h4 class="alert-heading">For få uddannelser?</h4>Husk at vælge <strong>alle</strong> de fag du har haft i gymnasiet. Ellers ser du ikke samtlige uddannelser, du kan søge ind på.',
            'result': 'uddannelse',
            'results': 'uddannelser',
        }
    } else {
        translations = {
            'nodata': 'No programmes match your search criteria.',
            'fewresults': '<h4 class="alert-heading">Not enough programmes?</h4>Remember to select <strong>all</strong> your subjects from upper secondary school in order to see all the programmes you can apply for.',
            'result': 'programme',
            'results': 'programmes',
        }
    }
    const FORM_DATA_ATTR = 'data-openhouseevents-filter-form';
    const STUDY_PROGRAMME_LIST_DATA_ATTR = 'data-study-programme-list';
    const LOAD_MORE_BUTTON_DATA_ATTR = 'data-openhouseevents-filter_load-more-button';
    const SHOW_LESS_BUTTON_DATA_ATTR = 'data-openhouseevents-filter_load-less-button';
    const LIMIT_INPUT_DATA_ATTR = 'data-openhouseevents-filter_limit';
    const TOPIC_SELECTED_COUNT_ATTR = 'data-openhouseevents-filter_topic-selected-count';
    const LOCATION_SELECTED_COUNT_ATTR = 'data-openhouseevents-filter_location-selected-count';
    const TAUGHT_LANGUAGES_SELECTED_COUNT_ATTR = 'data-openhouseevents-filter_taught-languages-selected-count';
    const STUDY_PROGRAMME_LIST_COUNT_ATTR = 'data-openhouseevents-filter_programme-list-count';
    const RESET_BUTTON_ATTR = 'data-openhouseevents-filter_reset-button';
    const RESET_BUTTON_NAMES_ATTR = 'data-openhouseevents-filter_reset-names';

    let abortControllers = [];

    function initListener() {
        // fetch api when click load more buttons
        const loadMoreButtons = document.querySelectorAll('[' + LOAD_MORE_BUTTON_DATA_ATTR + ']');
        for (let i = 0; i < loadMoreButtons.length; i++) {
            loadMoreButtons[i].addEventListener('click', async (evt) => {
                const ceUid = evt.currentTarget.getAttribute(LOAD_MORE_BUTTON_DATA_ATTR);

                // disable limit, when click at loadMoreButton to show ALL remaining programmes
                const limit = getLimitInput(ceUid);
                limit.disabled = true;

                await filterStudyProgrammes(ceUid);
            });
        }

        // fetch api when click show less buttons
        const showLessButtons = document.querySelectorAll('[' + SHOW_LESS_BUTTON_DATA_ATTR + ']');
        for (let i = 0; i < showLessButtons.length; i++) {
            showLessButtons[i].addEventListener('click', async (evt) => {
                const ceUid = evt.currentTarget.getAttribute(SHOW_LESS_BUTTON_DATA_ATTR);
                await resetAndLoadNewFilterProgrammes(ceUid);
            });
        }

        // fetch api at form changes
        const studyFilterForms = document.querySelectorAll('[' + FORM_DATA_ATTR + ']');
        for (let i = 0; i < studyFilterForms.length; i++) {
            studyFilterForms[i].addEventListener('input', async (evt) => {
                // in some cases (f.e. changing the school subjects), the form itself triggers an input, which would cause to double action
                // so do nothing, if form is the trigger part, we only want user form changes
                if (evt.target.tagName === 'FORM') {
                    return;
                }

                const ceUid = evt.currentTarget.getAttribute(FORM_DATA_ATTR);
                // when we change the filter, we have to reset all studyprogrammes
                await resetAndLoadNewFilterProgrammes(ceUid);
            });
        }
    }

    async function resetAndLoadNewFilterProgrammes(ceUid) {
        const studyProgrammeList = getStudyProgrammeList(ceUid);
        studyProgrammeList.innerHTML = '';
        // when we change the filter, we build offset from scratch and enable limit again
        showLoadMoreButton(ceUid);
        hideShowLessButton(ceUid);
        await filterStudyProgrammes(ceUid, true);
    }

    async function filterStudyProgrammes(ceUid, filterChanged = false) {
        const studyProgrammeResult = await fetchStudyProgrammes(ceUid, filterChanged);
        // maybe call is aborted, then ignore all following
        if (!studyProgrammeResult) {
            return;
        }

        const studyProgrammeList = getStudyProgrammeList(ceUid);
        studyProgrammeList.insertAdjacentHTML('beforeend', studyProgrammeResult.studyProgrammes);
        const studyProgrammeCount = getStudyProgrammeCount(ceUid);

        // show more or show less button handling
        // we dont need to respect the scenario to show the load more button here, because here we always output only the limit
        const limit = getLimitInput(ceUid);
        // hide both buttons, if total count of study programmes is lower or equal the limit
        if (+studyProgrammeResult.totalCount <= +limit.value) {
            hideLoadMoreButton(ceUid);
            hideShowLessButton(ceUid);
        }
        // hide load more button and show less button if amount of study programmes are the same as total amount
        else if (+studyProgrammeResult.totalCount === studyProgrammeCount) {
            hideLoadMoreButton(ceUid);
            showShowLessButton(ceUid);
        }

        // Warning if too few school subjects are chosen and we get between 1 and three results
        if (+studyProgrammeResult.totalCount > 0 && +studyProgrammeResult.totalCount < 4) {
            const schoolSubjectsCheckboxes = document.querySelectorAll('[name="schoolSubjects"]');
            for (let i = 0; i < schoolSubjectsCheckboxes.length; i++) {
                if (schoolSubjectsCheckboxes[i].type == 'checkbox') {
                    // Check if any of the checkboxes are checked
                    if (schoolSubjectsCheckboxes[i].checked) {
                        studyProgrammeList.insertAdjacentHTML('beforeend', `<article role="alert" aria-live="assertive" aria-atomic="true"><div class="alert alert-light" class="filter-no-data">${translations.fewresults}</div></article>`);
                        // Stop after first checked checkbox
                        break;
                    }
                }
            }
        }

        // If no results at all
        if (+studyProgrammeResult.totalCount === 0) {
            studyProgrammeList.insertAdjacentHTML('beforeend', `<div class="filter-no-data"><div role="alert" class="alert alert-light" aria-live="assertive" aria-atomic="true">${translations.nodata}</div></div>`);
        }

        // show number of shown study programme results
        // element is optional in frontend
        const studyProgrammeListCount = getStudyProgrammeListCount(ceUid);
        if (studyProgrammeListCount) {
            const suffix = +studyProgrammeResult.totalCount === 1 ? translations.result : translations.results;
            studyProgrammeListCount.innerHTML = +studyProgrammeResult.totalCount.toString() + ' ' + suffix;
        }
    }

    async function fetchStudyProgrammes(ceUid, filterChanged = false) {
        const studyFilterForm = getStudyFilterForm(ceUid);

        // when filter is changed, we have to enable limit again, before we take formData
        if (filterChanged) {
            const limit = getLimitInput(ceUid);
            limit.disabled = false;
        }

        const formData = new FormData(studyFilterForm);
        manipulateSubjectsValues(formData, studyFilterForm, 'topics');
        manipulateSubjectsValues(formData, studyFilterForm, 'locations');
        manipulateSubjectsValues(formData, studyFilterForm, 'taughtLanguages');

        // offset is current number of shown programmes
        // except we change filter, then offset is called from scratch
        formData.set('offset', filterChanged ? '0' : getStudyProgrammeCount(ceUid).toString());

        // set filter counts
        setFilterCounts(ceUid, studyFilterForm)

        // cancel former request
        abortControllers[ceUid]?.abort();

        // set new controller to maybe cancel
        abortControllers[ceUid] = new AbortController();
        const signal = abortControllers[ceUid].signal;

        // data-basepath could contain ending slash or not, we have to respect both
        const basePath = studyFilterForm.getAttribute('data-basepath');
        return fetch(basePath + (basePath.endsWith('/') ? '' : '/') + 'openhouseevents-filter-api/openhouseevents-filter', {
            method: 'POST',
            signal: signal,
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(Object.fromEntries(formData))
        })
            .then((response) => response.json())
            .then(response => {
                return response;
            })
            .catch((error) => {
                // Do nothing if we are catching an abort, otherwise re-throw to avoid swallowing errors
                if (error.name !== 'AbortError') {
                    throw error;
                }
            });
    }

    /**
     * set checkboxes as list
     */
    function manipulateSubjectsValues(formData, studyFilterForm, propertyName) {
        const values = getCheckedValues(studyFilterForm, propertyName);
        formData.set(propertyName, values);
    }

    function getCheckedValues(studyFilterForm, propertyName) {
        const checkedValues = [];
        const elements = studyFilterForm.elements[propertyName];
        for (let i = 0; i < elements?.length; i++) {
            if (elements[i].checked) {
                checkedValues.push(elements[i].value);
            }
        }
        return checkedValues;
    }

    /**
     * count of 0 is mpt shown, show empty string instead
     */
    function setFilterCounts(ceUid, studyFilterForm) {
        const topicSelectedCount = getTopicSelectedCount(ceUid);
        const locationsSelectedCount = getLocationsSelectedCount(ceUid);
        const taughtLanguagesSelectedCount = getTaughtLanguagesSelectedCount(ceUid);

        if (topicSelectedCount) {
            topicSelectedCount.innerHTML = getCheckedValues(studyFilterForm, 'topics').length ? getCheckedValues(studyFilterForm, 'topics').length.toString() : '';
        }
        if (locationsSelectedCount) {
            locationsSelectedCount.innerHTML = getCheckedValues(studyFilterForm, 'locations').length ? getCheckedValues(studyFilterForm, 'locations').length.toString() : '';
        }
        if (taughtLanguagesSelectedCount) {
            taughtLanguagesSelectedCount.innerHTML = getCheckedValues(studyFilterForm, 'taughtLanguages').length ? getCheckedValues(studyFilterForm, 'taughtLanguages').length.toString() : '';
        }
    }

    function getStudyProgrammeCount(ceUid) {
        return document.querySelectorAll('#c' + ceUid + ' [data-openhousevents-study-programme]').length;
    }

    function showLoadMoreButton(ceUid) {
        getLoadMoreButton(ceUid).style.display = 'block';
    }

    function hideLoadMoreButton(ceUid) {
        getLoadMoreButton(ceUid).style.display = 'none';
    }

    function showShowLessButton(ceUid) {
        getShowLessButton(ceUid).style.display = 'block';
    }

    function hideShowLessButton(ceUid) {
        getShowLessButton(ceUid).style.display = 'none';
    }

    function getStudyFilterForm(ceUid) {
        return document.querySelector('[' + FORM_DATA_ATTR + '="' + ceUid + '"]');
    }

    function getStudyProgrammeList(ceUid) {
        return document.querySelector('[' + STUDY_PROGRAMME_LIST_DATA_ATTR + '="' + ceUid + '"]');
    }

    function getLoadMoreButton(ceUid) {
        return document.querySelector('[' + LOAD_MORE_BUTTON_DATA_ATTR + '="' + ceUid + '"]');
    }

    function getShowLessButton(ceUid) {
        return document.querySelector('[' + SHOW_LESS_BUTTON_DATA_ATTR + '="' + ceUid + '"]');
    }

    function getLimitInput(ceUid) {
        return document.querySelector('[' + LIMIT_INPUT_DATA_ATTR + '="' + ceUid + '"]');
    }

    function getTopicSelectedCount(ceUid) {
        return document.querySelector('[' + TOPIC_SELECTED_COUNT_ATTR + '="' + ceUid + '"]');
    }

    function getLocationsSelectedCount(ceUid) {
        return document.querySelector('[' + LOCATION_SELECTED_COUNT_ATTR + '="' + ceUid + '"]');
    }

    function getTaughtLanguagesSelectedCount(ceUid) {
        return document.querySelector('[' + TAUGHT_LANGUAGES_SELECTED_COUNT_ATTR + '="' + ceUid + '"]');
    }

    function getStudyProgrammeListCount(ceUid) {
        return document.querySelector('[' + STUDY_PROGRAMME_LIST_COUNT_ATTR + '="' + ceUid + '"]');
    }

    function getCeUidArray() {
        return Array.from(document.querySelectorAll('[' + FORM_DATA_ATTR + ']')).map(element => element.getAttribute(FORM_DATA_ATTR));
    }

    initListener();
    // initial call for each form
    getCeUidArray().forEach(ceUid => filterStudyProgrammes(ceUid));

    // Show/hide filter content
    const show = (elem) => {
        hideAllElements();
        elem.parentNode.classList.add('active');
        elem.classList.add('is-visible');
        elem.setAttribute('tabindex', '1');
        elem.querySelector('.form-check-input').focus();
    };

    const hide = (elem) => {
        elem.parentNode.classList.remove('active');
        elem.classList.remove('is-visible');
        elem.setAttribute('tabindex', '0');
    };

    const hideAllElements = () => {
        // Hide content
        document.querySelectorAll('.study-selections.active').forEach((elem) => {
            elem.classList.remove('active');
        });

        const visibleElements = document.querySelectorAll('.is-visible');
        for (const element of visibleElements) {
            element.classList.remove('is-visible');
        }
    };

    const toggle = (elem) => {
        // If the element is visible, hide it
        if (elem.classList.contains('is-visible')) {
            hide(elem);
            return;
        }
        // Otherwise, show it
        show(elem);
    };

    let buttons = document.querySelectorAll('.btn-openhouseevents-filter');
    const resetButtons = () => {
        if (!buttons) return;
        buttons.forEach((btn) => {
            btn.classList.add('collapsed');
            btn.setAttribute('aria-selected', false);
        })
    }

    if (buttons) {
        buttons.forEach((btn) => {
            btn.addEventListener('click', (evt) => {

                // Get the selected content
                let content = document.querySelector(btn.dataset.href);
                if (!content) return;

                // Toggle the content
                toggle(content);

                // Update toggle buttons
                if (!btn.classList.contains('btn-openhouseevents-filter')) return;
                if (btn.classList.contains('collapsed')) {
                    // Open
                    resetButtons();
                    btn.classList.remove('collapsed');
                } else {
                    // Cloaed
                    btn.classList.add('collapsed');
                }
                // Update aria attributes
                btn.setAttribute('aria-selected', `${(btn.getAttribute('aria-selected') !== 'true').toString()}`);
            });
        });
    }

    const closeFilter = () => {
        // Close filters
        const close = document.querySelectorAll('.close-filter');
        if (!close) return;

        close.forEach((btn) => {
            btn.addEventListener('click', () => {
                resetButtons();
                hideAllElements();
            });
        });
    }
    closeFilter();

    const clearForm = () => {
        // Reset form and show all results
        const resetButtons = document.querySelectorAll('[' + FORM_DATA_ATTR + '] [' + RESET_BUTTON_ATTR + ']');
        if (!resetButtons) return;

        // reset all parts correctly where reset buttons are clicked
        resetButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const ceUid = btn.getAttribute(RESET_BUTTON_ATTR);

                // call belonging form
                const belongingForm = document.querySelector('[' + FORM_DATA_ATTR + '="' + ceUid + '"]');
                // get name-attributes to reset and split them to an array, because it could be several
                const resetNames = btn.getAttribute(RESET_BUTTON_NAMES_ATTR);
                const resetNamesArray = resetNames.split(',');

                // set all these form elements to unchecked
                resetNamesArray.forEach(n => {
                    const formElements = belongingForm.querySelectorAll('[name=' + n + ']');
                    formElements.forEach(el => {
                        switch (el.type) {
                            case 'radio':
                            case 'checkbox':
                                el.checked = false;
                                break;
                            case 'search':
                            case 'text':
                            case 'hidden':
                                el.value = '';
                                break;
                        }
                    });
                });

                // reset all studyprogrammes
                resetAndLoadNewFilterProgrammes(ceUid);
            });
        });
    }
    clearForm();

    const scrollToTop = () => {
        // Scroll to top of form in mobile view when clicking OK button
        if (window.matchMedia('(max-width: 1199px)').matches) {
            const okButtons = document.querySelectorAll('[' + FORM_DATA_ATTR + '] .close-filter');
            if (!okButtons) return;

            okButtons.forEach((btn) => {
                btn.addEventListener('click', () => {
                    const ceUid = btn.getAttribute('data-openhouseevents-filter_ok-button');
                    getStudyFilterForm(ceUid).scrollIntoView();
                });
            });
        }
    }

    scrollToTop();
});
